import { render } from "./CommunityEng.vue?vue&type=template&id=7b754b8c"
import script from "./CommunityEng.vue?vue&type=script&lang=js"
export * from "./CommunityEng.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__